var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('grid-component',{attrs:{"isResizable":"","isReorderable":"","gridId":_vm.gridId,"fields":_vm.fields,"itemData":_vm.inventorySplitList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }